import React  from "react";
import {Button,Card,Form,Container,Row,Col} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import Select from 'react-select'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import 'moment/locale/es';
import { useFichaParticipacionGrupal } from "hooks/useFichaParticipacionGrupal";

function EditarParticipacionGrupal(){
  
  const parametros = useParams();
  
  const { 
      usuariosTo,
      usuariosSicologas,
      usuariosOtros,
      editParticipacionGrupal,
      respuestaEditarParticipacion,
      participacionFicha,
      setParticipacionFicha,
      updateRespuestaEditarParticipacion      
      
  } = useFichaParticipacionGrupal(parametros.participacionGrupalId);

  let opcionesSelectorTO=[];
        let opcionesSelectorPsicologas=[];
        let opcionesSelectorOtros=[];

  usuariosTo?.map((elem)=>{
    opcionesSelectorTO.push(
          {
              value:elem.Usuario,
              label:elem.NombreSocial 
            }
      )
  });
  usuariosSicologas?.map((elem)=>{
      opcionesSelectorPsicologas.push(
            {
                value:elem.Usuario,
                label:elem.NombreSocial 
              }
        )
  });
  usuariosOtros?.map((elem)=>{
      opcionesSelectorOtros.push(
            {
                value:elem.Usuario,
                label:elem.NombreSocial 
              }
        )
  });

const editarParticipacionGrupal = async() => {
    const resp=await editParticipacionGrupal(participacionFicha);
    updateRespuestaEditarParticipacion()
      
};

  return (
    <>
      <Container fluid>
      <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Editar Participación Grupal</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                                 
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Nombre Social</label>
                        <Form.Control
                          value={participacionFicha?.NombreSocial}
                          placeholder=""
                          type="text"
                          disabled
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                    <Form.Group>
                        <label>Rut</label>
                        <Form.Control
                          value={participacionFicha?.Rut}
                          placeholder=""
                          type="text"
                          disabled
                        ></Form.Control>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="6">
                    <label>Profesionales Psicóloga</label><br></br>
                    <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        options={opcionesSelectorPsicologas}
                        value={opcionesSelectorPsicologas?.filter(item => participacionFicha?.ProfesionalSicologa?.includes(item.value))}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={ (e,prop) => {
                          let valorArreglo=[];
                          for(var i=0;i<e.length;i++){
                            valorArreglo.push(e[i].value)
                          }
                          setParticipacionFicha({...participacionFicha,['ProfesionalSicologa']:valorArreglo});
                        }}
                        
                        />
                    </Col>
                    <Col xs="6">
                        <label>Profesionales Terapeuta Ocupacional</label>
                        <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        options={opcionesSelectorTO}
                        value={opcionesSelectorTO?.filter(item => participacionFicha?.ProfesionalTo?.includes(item.value))}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={ (e,prop) => { 
                          let valorArreglo=[];
                          for(var i=0;i<e.length;i++){
                            valorArreglo.push(e[i].value)
                          }
                          setParticipacionFicha({...participacionFicha,['ProfesionalTo']:valorArreglo});
                        }}
                       
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs="6">
                    <label>Profesionales Otros</label><br></br>
                    <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        options={opcionesSelectorOtros}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={opcionesSelectorOtros?.filter(item => participacionFicha?.ProfesionalOtro?.includes(item.value))}
                        onChange={ (e,prop) => { 
                          let valorArreglo=[];
                          for(var i=0;i<e.length;i++){
                            valorArreglo.push(e[i].value)
                          }
                          setParticipacionFicha({...participacionFicha,['ProfesionalOtro']:valorArreglo});
                           
                        }}
                        
                        />
                    </Col>
                    <Col xs="6">
                        <label>Fecha Sesión (Hora Santiago,Chile)</label>
                        <Datetime
                            value={moment(participacionFicha?.FechaSesion)}
                            utc={true}
                            onChange={(date) => {
                              const d = moment(date);
                              setParticipacionFicha({...participacionFicha,['FechaSesion']:d});
                            }}
                            
                        ></Datetime>
                         
                      
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                 
                    <label>Comentarios</label>
                    <Form.Control
                       
                        value={participacionFicha?.Comentario}
                        placeholder=""
                        type="textarea"
                        as="textarea"
                        maxLength={4000}
                        onChange={ (e,prop) => { 
                          let valor=e.target.value;
                          valor=valor.slice(0, 4000);
                          setParticipacionFicha({...participacionFicha,['Comentario']:valor});
                        }}
                        rows={12}>

                    </Form.Control>
                    <div style={{ textAlign: 'right', marginTop: 4, color: '#666' }}>
                        {participacionFicha?.Comentario?.length} / {4000}
                    </div>
                   
                    </Col>
                   
                </Row>
                 
                  <Button
                    className="btn-fill pull-right"
                    type="submit"
                    variant="info"
                    onClick={(e)=>{
                      e.preventDefault();
                      editarParticipacionGrupal();}}>
                    Guardar
                  </Button>
                  
                  <div className="clearfix"></div>
                  <br></br>
                  <MensajeAlerta mensajeTexto={respuestaEditarParticipacion.mensajeTexto} estado={respuestaEditarParticipacion.estado} />
                  
                </Form>
              </Card.Body>
            </Card>
          </Col>
          
          
      </Row>
       
      </Container>
    </>
  );
  
}

export default EditarParticipacionGrupal;
